import React, { useState } from 'react';

const categoryToSlug = (cat) =>
  (cat || '').toLowerCase().replace(/&/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

const BlogShare = ({ blog, expanded = false }) => {
  const [copied, setCopied] = useState(false);

  const url = blog
    ? `${window.location.origin}/${blog.type || 'blog'}/${categoryToSlug(blog.category)}/${blog.slug}`
    : window.location.href;
  const title = blog?.title || '';

  const shareLinks = {
    whatsapp: `https://wa.me/?text=${encodeURIComponent(title + '\n' + url)}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      console.error('Copy failed:', e);
    }
  };

  return (
    <div className={`blog_share ${expanded ? 'blog_share--expanded' : ''}`}>
      <a
        href={shareLinks.whatsapp}
        target="_blank"
        rel="noopener noreferrer"
        className="share_btn share_btn--whatsapp"
        aria-label="Share on WhatsApp"
        title="Share on WhatsApp"
      >
        <i className="fa-brands fa-whatsapp"></i>
        {expanded && <span>WhatsApp</span>}
      </a>
      <a
        href={shareLinks.linkedin}
        target="_blank"
        rel="noopener noreferrer"
        className="share_btn share_btn--linkedin"
        aria-label="Share on LinkedIn"
        title="Share on LinkedIn"
      >
        <i className="fa-brands fa-linkedin-in"></i>
        {expanded && <span>LinkedIn</span>}
      </a>
      <a
        href={shareLinks.twitter}
        target="_blank"
        rel="noopener noreferrer"
        className="share_btn share_btn--twitter"
        aria-label="Share on Twitter"
        title="Share on Twitter"
      >
        <i className="fa-brands fa-x-twitter"></i>
        {expanded && <span>Twitter</span>}
      </a>
      <a
        href={shareLinks.facebook}
        target="_blank"
        rel="noopener noreferrer"
        className="share_btn share_btn--facebook"
        aria-label="Share on Facebook"
        title="Share on Facebook"
      >
        <i className="fa-brands fa-facebook-f"></i>
        {expanded && <span>Facebook</span>}
      </a>
      <button
        type="button"
        className={`share_btn share_btn--copy ${copied ? 'copied' : ''}`}
        onClick={handleCopy}
        aria-label={copied ? 'Copied!' : 'Copy link'}
        title={copied ? 'Copied!' : 'Copy link'}
      >
        <i className={`fa-solid ${copied ? 'fa-check' : 'fa-link'}`}></i>
        {expanded && <span>{copied ? 'Copied!' : 'Copy Link'}</span>}
      </button>
    </div>
  );
};

export default BlogShare;
